import { render } from "./generateHtml.vue?vue&type=template&id=31841358"
import script from "./generateHtml.vue?vue&type=script&lang=js"
export * from "./generateHtml.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__